import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import { useController, useFormContext, useWatch } from "react-hook-form";
import FormAutocompleteTC from "../../../components/Forms/FormAutocompleteTC";
import { displayOnScreenGroup } from "../../../variables/app";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import { convertObjectToSelectOptions } from "../../../templateHelpers";
import FormCustomizableTextTC from "../../../components/Forms/FormCustomizableTextTC";

function Algemeen() {
  const categorys = [
    { value: "eten", label: "Eten" },
    { value: "drinken", label: "Drinken" },
  ];
  const kitchenDisplay = convertObjectToSelectOptions(displayOnScreenGroup);
  const modelId = useWatch({ name: "id" });
  const { setValue, getValues, watch, vestigingId } = useFormContext();
  useController({ name: "titleMenuItem" });

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === "naam") {
        const titleMenuItemValue = getValues("titleMenuItem");
        if (titleMenuItemValue === 0 && value?.naam !== getValues("titleMenuDescr")) {
          setValue("titleMenuDescr", value?.naam, { shouldDirty: true });
        }
      } else if (name === "titleMenuDescr") {
        const titleMenuItemValue = getValues("titleMenuItem");
        const nameValue = getValues("naam");
        if (titleMenuItemValue !== 0 && nameValue === value?.titleMenuDescr) {
          setValue("titleMenuItem", 0, { shouldDirty: true });
        } else if (titleMenuItemValue === 0 && nameValue !== value?.titleMenuDescr) {
          setValue("titleMenuItem", 1, { shouldDirty: true });
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, getValues]);

  const snaamValue = watch("snaam");
  const naamValue = watch("naam");

  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <Grid container spacing={3}>
        <Grid item lg={6} xs={12}>
          <Card>
            <CardBody style={{ padding: 16 }}>
              <Grid container spacing={1}>
                <FormTextTC name={"naam"} tDefault={"Name"} tKey={"menukaarten.form.algemeen.label.naam"} />
                {snaamValue != null && snaamValue !== naamValue ? (
                  <FormTextTC
                    fieldProps={{ disabled: true }}
                    name={"snaam"}
                    tDefault={"POS Name"}
                    tKey={"menukaarten.form.algemeen.label.posnaam"}
                  />
                ) : null}
                <FormTextTC name={"titleMenuDescr"} tKey={"Custom name"} />

                <FormTextTC
                  name={"bigdescr"}
                  rows={5}
                  tDefault={"Omschrijving"}
                  tKey={"menukaarten.form.algemeen.label.omschrijving"}
                />

                <FormAutocompleteTC
                  freeSolo={true}
                  name={"categorie"}
                  nullable={true}
                  options={categorys}
                  tDefault={"Groep"}
                  tKey={"menukaarten.form.algemeen.label.categorie"}
                />

                <FormAsyncTC
                  async={{
                    url:
                      "core/printers/search?fields=id as value, name as label&per_page=50&vestiging_id=" + vestigingId,
                    searchField: "name",
                  }}
                  key={"printer_id" + vestigingId}
                  name={"printer_id"}
                  nullable={true}
                  tDefault={"Printer"}
                  tKey={"menukaarten.form.algemeen.label.printer_id"}
                />

                <FormTextTC name={"kitchen"} tDefault={"Kitchen"} tKey={"menukaarten.form.algemeen.label.kitchen"} />
                <FormTextTC
                  name={"specialiteit"}
                  tDefault={"Kitchen specialty"}
                  tKey={"menukaarten.form.algemeen.label.kitchenspecialty"}
                />

                <FormTextTC name={"ledger"} tDefault={"# Ledger"} tKey={"producten.form.algemeen.label.ledger"} />

                <FormControlledInputTC
                  name={"minValue"}
                  rules={{
                    min: {
                      value: 0,
                      message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                    },
                  }}
                  tDefault={"Min order value"}
                  tKey={"menukaarten.form.algemeen.label.minOrderValue"}
                  type={"currency"}
                />

                <FormControlledInputTC
                  name={"vaPrice"}
                  rules={{
                    min: {
                      value: 0,
                      message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                    },
                  }}
                  tKey={"Price label"}
                  type={"currency"}
                />

                <FormTextTC
                  name={"sentToMail"}
                  tDefault={"Mail naar dit adress als er producten van deze menukaarten in de bestelling zitten."}
                  tKey={"menukaarten.form.algemeen.label.sentToMail"}
                  textFieldType={"email"}
                />
                <FormAsyncTC
                  async={{
                    url:
                      "core/kaarten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                      vestigingId,
                    searchField: "naam",
                  }}
                  key={"parent_id" + vestigingId}
                  name={"parent_id"}
                  nullable={true}
                  tDefault={"Hoofd menukaart"}
                  tKey={"menukaarten.form.algemeen.label.parent_id"}
                />
              </Grid>
            </CardBody>
          </Card>
        </Grid>
        <Grid item lg={6} xs={12}>
          <Card>
            <CardBody style={{ padding: 16 }}>
              <Grid container spacing={1}>
                <FormSwitchTC
                  name={"is_actief"}
                  tDefault={"Actief"}
                  tKey={"menukaarten.form.algemeen.label.is_actief"}
                />
                <FormSwitchTC
                  name={"blocked"}
                  tDefault={"Blokkeren in jamezz"}
                  tKey={"producten.form.algemeen.label.blocked"}
                />
                <FormSwitchTC
                  name={"showInCategoryMenu"}
                  tDefault={"Weergeven in categorie overzicht"}
                  tKey={"menukaarten.form.algemeen.label.showInCategoryMenu"}
                />
                <FormSwitchTC
                  name={"disableOrdering"}
                  tDefault={"Disable ordering"}
                  tKey={"menukaarten.form.algemeen.label.disableOrdering"}
                />
                <FormCustomizableTextTC
                  model={"menukaart"}
                  modelId={modelId}
                  tDefault={"Why disabled? This information is shown in the app."}
                  tKey={"menukaarten.form.algemeen.label.reason_disabled_ordering"}
                  translatableText={"reason_disabled_ordering"}
                />

                <FormSwitchTC
                  name={"showSubItems"}
                  tDefault={"Show subgroup items"}
                  tKey={"menukaarten.form.algemeen.label.showSubItems"}
                />
                <FormSelectTC
                  name={"onOrderscreen"}
                  options={kitchenDisplay}
                  tDefault={"Display on order screen"}
                  tKey={"producten.form.algemeen.label.onOrderscreen"}
                />
                <FormSwitchTC
                  name={"showOnAllKsWithItems"}
                  tDefault={"Show on all screens with products"}
                  tKey={"producten.form.algemeen.label.showOnAllKsWithItems"}
                />
                <FormSwitchTC
                  name={"settings.disable_multi_area_sync"}
                  tDefault={"Disable multi area sync for this category"}
                  tKey={"menukaarten.form.algemeen.label.disable_multi_area_sync"}
                />
              </Grid>
            </CardBody>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}

export default Algemeen;
